import React, { useEffect, useState } from "react";
import Modal from "@/common/elements/Modal";
import InmateAssociatesForm from "./InmateAssociatesForm";
import { hasCheckSecurity } from "@/util/common_function";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { MODULES_LIST_WITH_ID, SUB_MODULES_LIST_WITH_ID } from "@/util/common_variable";
import { useSelector } from "react-redux";

const InmateAssociatesModal = ({
  show,
  onHide,
  selectedAssociate,
  associateFormRef,
  updateStoreObj,
  isEdit,
  setIsEdit
}) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const { bookingsFieldsEnabled } = useSelector(
      (state) => state.bookings
    );
    useEffect(() => {
        if (isEdit) {
            let isShow = hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.MODIFY,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Arrest_Report
            )
            if (isShow) {
                setIsDisabled(false)
            }
            else {
                setIsDisabled(true)
            }
        } else {
            setIsDisabled(false)
        }
    }, [isEdit])
  const onModalHide = () => {
    onHide();
    setIsEdit(false)
  };

  // When save is clicked in the modal, the externally provided updateStoreObj
  // function is called. This function should use associateFormRef to obtain the
  // form values and update Redux accordingly.
  const onSaveClick = () => {
    updateStoreObj();
  };

  return (
    <Modal
      header="Inmate Associates Information"
      show={show}
      onHide={onModalHide}
      size="xl"
      footerActions={[
        {
          key: "save",
          text: "Save",
          onClick: onSaveClick,
          disabled:isDisabled || !bookingsFieldsEnabled,
        },
      ]}
      footerCloseAction={()=> setIsEdit(false)  }
      footerCloseActionText="Close"
    >
   <InmateAssociatesForm 
  ref={associateFormRef} 
  selectedAssociate={selectedAssociate} 
/>

    </Modal>
  );
};

export default InmateAssociatesModal;
